/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ScheduleDetail,
  ErrorInfo,
  ScheduleCalculateResult,
  ScheduleCalculateParams,
  GetScheduleMasters200,
  PostScheduleMastersSave200,
  PostScheduleMastersSaveBody
} from '.././model'


/**
 * 日程情報を日程履歴テーブル、日程項目テーブルなどから計算して取得する。

 * @summary 日程取得
 */
export const getScheduleDetail = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ScheduleDetail>> => {
    return axios.get(
      `/schedules/detail/${productionId}`,options
    );
  }


export const getGetScheduleDetailQueryKey = (productionId: number,) => [`/schedules/detail/${productionId}`];

    
export type GetScheduleDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleDetail>>>
export type GetScheduleDetailQueryError = AxiosError<ErrorInfo>

export const useGetScheduleDetail = <TData = Awaited<ReturnType<typeof getScheduleDetail>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScheduleDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduleDetailQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleDetail>>> = ({ signal }) => getScheduleDetail(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getScheduleDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 日程情報を自動計算する。

 * @summary 日程自動計算
 */
export const postScheduleCalculate = (
    productionId: number,
    scheduleCalculateParams: ScheduleCalculateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ScheduleCalculateResult>> => {
    return axios.post(
      `/schedules/calculate/${productionId}`,
      scheduleCalculateParams,options
    );
  }



    export type PostScheduleCalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleCalculate>>>
    export type PostScheduleCalculateMutationBody = ScheduleCalculateParams
    export type PostScheduleCalculateMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleCalculate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleCalculate>>, TError,{productionId: number;data: ScheduleCalculateParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleCalculate>>, {productionId: number;data: ScheduleCalculateParams}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postScheduleCalculate(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleCalculate>>, TError, {productionId: number;data: ScheduleCalculateParams}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 日程情報を日程履歴テーブル、日程項目テーブルなどに保存する。

 * @summary 日程保存
 */
export const postScheduleSave = (
    scheduleDetail: ScheduleDetail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/schedules/save`,
      scheduleDetail,options
    );
  }



    export type PostScheduleSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleSave>>>
    export type PostScheduleSaveMutationBody = ScheduleDetail
    export type PostScheduleSaveMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleSave>>, TError,{data: ScheduleDetail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleSave>>, {data: ScheduleDetail}> = (props) => {
          const {data} = props ?? {};

          return  postScheduleSave(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleSave>>, TError, {data: ScheduleDetail}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（日程編集タブ）の編集ロック処理。  
制作管理編集テーブルのレコードに編集対象、編集ロックセッションID、開始日時、有効期限等を設定する。
現在ロックをしているセッションから呼ばれたときは、編集ロックの有効期限を延長する。

 * @summary 制作管理（日程編集タブ）編集ロック
 */
export const postScheduleLock = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/schedules/lock/${productionId}`,undefined,options
    );
  }



    export type PostScheduleLockMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleLock>>>
    
    export type PostScheduleLockMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleLock>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleLock>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postScheduleLock(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleLock>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（日程編集タブ）の編集をキャンセルし、編集ロックを解除する。

 * @summary 制作管理（日程編集タブ）編集キャンセル・ロック解除
 */
export const postScheduleCancel = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/schedules/cancel/${productionId}`,undefined,options
    );
  }



    export type PostScheduleCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleCancel>>>
    
    export type PostScheduleCancelMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleCancel>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleCancel>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postScheduleCancel(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleCancel>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（日程編集タブ）の日程変更を通知する。

 * @summary 制作管理（日程編集タブ）の日程変更通知
 */
export const postScheduleNotify = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/schedules/notify/${productionId}`,undefined,options
    );
  }



    export type PostScheduleNotifyMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleNotify>>>
    
    export type PostScheduleNotifyMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleNotify = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleNotify>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleNotify>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postScheduleNotify(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleNotify>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 日程マスタ、サブ日程マスタの情報を表示

 * @summary 日程マスタ一覧取得
 */
export const getScheduleMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetScheduleMasters200>> => {
    return axios.get(
      `/schedules/masters`,options
    );
  }


export const getGetScheduleMastersQueryKey = () => [`/schedules/masters`];

    
export type GetScheduleMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleMasters>>>
export type GetScheduleMastersQueryError = AxiosError<ErrorInfo>

export const useGetScheduleMasters = <TData = Awaited<ReturnType<typeof getScheduleMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScheduleMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduleMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleMasters>>> = ({ signal }) => getScheduleMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getScheduleMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 日程マスタ、サブ日程マスタの情報を保存

 * @summary 日程マスタ保存
 */
export const postScheduleMastersSave = (
    postScheduleMastersSaveBody: PostScheduleMastersSaveBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostScheduleMastersSave200>> => {
    return axios.post(
      `/schedules/masters/save`,
      postScheduleMastersSaveBody,options
    );
  }



    export type PostScheduleMastersSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleMastersSave>>>
    export type PostScheduleMastersSaveMutationBody = PostScheduleMastersSaveBody
    export type PostScheduleMastersSaveMutationError = AxiosError<ErrorInfo>

    export const usePostScheduleMastersSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleMastersSave>>, TError,{data: PostScheduleMastersSaveBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleMastersSave>>, {data: PostScheduleMastersSaveBody}> = (props) => {
          const {data} = props ?? {};

          return  postScheduleMastersSave(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postScheduleMastersSave>>, TError, {data: PostScheduleMastersSaveBody}, TContext>(mutationFn, mutationOptions)
    }
    